import React from 'react';
import { CTAButton } from './CTAButton';
export const ValorPercibido: React.FC = () => {
  const items = [{
    emoji: '📚',
    title: 'Biblioteca Disney Completa',
    description: 'Más de 50 libros y 2.500 páginas',
    value: '$29.990'
  }, {
    emoji: '👑',
    title: 'Colección Princesas Premium',
    description: 'Princesas favoritas, todas juntas',
    value: '$9.990'
  }, {
    emoji: '🎬',
    title: 'Colección Pixar Premium',
    description: 'Cars, Toy Story, Monsters, Moana',
    value: '$9.990'
  }, {
    emoji: '🦹',
    title: 'Colección Villanos Premium',
    description: 'Los personajes más buscados',
    value: '$9.990'
  }, {
    emoji: '⭐',
    title: 'Pack Exclusivo de Personajes Favoritos',
    description: 'Mickey, Stitch, Frozen y más',
    value: '$14.990'
  }, {
    emoji: '🖨️',
    title: 'Impresión Ilimitada',
    description: 'Imprimí las veces que quieras, para siempre',
    value: '$10.000'
  }, {
    emoji: '⚡',
    title: 'Acceso Inmediato',
    description: 'Descarga al instante tras la compra',
    value: '$5.000'
  }];
  return <section className="py-8 px-4 bg-cream" data-id="element-250">
      <div className="max-w-2xl mx-auto" data-id="element-251">
        <div className="text-center mb-6" data-id="element-252">
          <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet leading-tight" data-id="element-253">
            Todo lo que <span className="text-gold-dark" data-id="element-254">recibís hoy</span>
          </h2>
        </div>

        <div className="bg-white rounded-3xl border-2 border-gold/50 shadow-card overflow-hidden mb-5" data-id="element-255">
          <ul data-id="element-256">
            {items.map((item, idx) => <li key={idx} className={`flex items-start gap-3 px-5 py-4 ${idx !== items.length - 1 ? 'border-b-2 border-dashed border-cream-dark' : ''}`} data-id="element-257">
                <span className="text-3xl flex-shrink-0 leading-none" data-id="element-258">
                  {item.emoji}
                </span>
                <div className="flex-grow min-w-0" data-id="element-259">
                  <div className="flex items-start justify-between gap-2 mb-0.5" data-id="element-260">
                    <h3 className="font-rounded font-bold text-violet text-sm sm:text-base leading-tight" data-id="element-261">
                      {item.title}
                    </h3>
                    <span className="font-rounded font-bold text-violet text-sm whitespace-nowrap" data-id="element-262">
                      {item.value}
                    </span>
                  </div>
                  <p className="text-xs sm:text-sm text-textsoft font-semibold leading-snug" data-id="element-263">
                    {item.description}
                  </p>
                </div>
              </li>)}
          </ul>

          <div className="bg-cream-dark/70 px-5 py-4 border-t-[3px] border-gold" data-id="element-264">
            <div className="flex items-center justify-between mb-2" data-id="element-265">
              <span className="font-rounded font-bold text-violet text-sm sm:text-base" data-id="element-266">
                Valor real total:
              </span>
              <span className="font-rounded font-bold text-gray-400 line-through text-lg" data-id="element-267">
                $89.960
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-268">
              <span className="font-rounded font-bold text-violet text-base sm:text-lg uppercase" data-id="element-269">
                Hoy pagás solo:
              </span>
              <span className="font-rounded font-bold text-violet text-2xl sm:text-3xl" data-id="element-270">
                $19.990
              </span>
            </div>
            <p className="text-center text-xs sm:text-sm font-bold text-brandgreen mt-2" data-id="element-271">
              🎉 Ahorrás $69.970
            </p>
          </div>
        </div>

        <CTAButton data-id="element-272" />
      </div>
    </section>;
};